<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="LINESPACE" id="fmtext"> </p>
<p class="LINESPACE"> </p>
<p class="FM-TEXT">On August 18, 1813, almost four years after the death of Meriwether Lewis, Thomas Jefferson wrote of the explorer, “Of courage undaunted, possessing a firmness &amp; perseverance of purpose which nothing but impossibilities could divert from its direction, careful as a father to those committed to his charge…”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fmtext.vue?178fe4c3